import request from 'store/common/utils';
export const getProjectConfigurationsApi = (projectId) => request({
    url: `/projects/${projectId}/configurations`,
    method: 'GET',
});
export const createProjectConfigurationsApi = (projectId, data) => request({
    url: `/projects/${projectId}/configurations`,
    method: 'POST',
    data,
});
export const editProjectConfigurationsApi = (projectId, data) => request({
    url: `/projects/${projectId}/configurations`,
    method: 'PUT',
    data,
});
export const deleteProjectConfigurationsApi = (projectId, configurationIds) => request({
    url: `/projects/${projectId}/configurations/delete-batch`,
    method: 'POST',
    data: { ids: configurationIds },
});
